import React, { Component } from 'react'
import { inject, observer } from 'mobx-react';
import { Card, Icon } from 'antd';
import CustomRouter from '../../stores/CustomRouter';
import NavViews from '../../stores/NavViews';
import { getTeamInfo as getTeamInfoApi } from '../../api-calls/sportsDbApi';
import { getTeamPlayers as getTeamPlayersApi } from '../../api-calls/sportsDbApi';
import { FaExternalLinkAlt, FaFacebook, FaInstagram, FaTwitterSquare, FaYoutubeSquare } from 'react-icons/fa';


import FollowTeamBtn from '../layoutComponents/followButtons/FollowTeamBtn';


@observer(["web3Store", "eventStore", "WagerStore", "CustomRouter", "ViewStore", "TeamStore"])
class Team extends Component {
    constructor(props) {
        super(props);

        this.state = {
            currentTeam: {},
            teamFromApi: {},
            playersFromApi: {},
            loading: true,
            loadingPlayers: true,
        };
        this.renderPlayers = this.renderPlayers.bind(this);
    }

    async componentDidMount() {
        const { CustomRouter, TeamStore } = this.props;
        const { router: { params } } = CustomRouter;
        let self = this;
        this.props.TeamStore.querySingleTeam(params.teamID).then(() => {

            setTimeout(() => {
                let currentTeamArray = Array.from(TeamStore.team.values())
                let singleTeamObj = currentTeamArray[0];
                self.setState({ currentTeam: singleTeamObj })
            }, 100)
            setTimeout(() => {
                self.props.ViewStore.changeCurrentPage('Team');
                this.props.ViewStore.changeView('Team / ' + this.state.currentTeam.name);
                getTeamInfoApi(this.state.currentTeam.apiId).then((res) => {
                    let currentApiTeamArray = Array.from(res.teams);
                    let singleApiTeamObj = currentApiTeamArray[0];
                    this.setState({ teamFromApi: singleApiTeamObj })
                });
                getTeamPlayersApi(this.state.currentTeam.apiId).then((res) => {
                    this.setState({ playersFromApi: Array.from(res.player) });
                    console.log(this.state.playersFromApi);
                    self.setState({ loading: false })

                });

            }, 200)

            setTimeout(() => {
                self.setState({ loadingPlayers: false })

            }, 600)

        });


    }
    renderPlayers() {
        let playerList = [];
        let logoUrl = require('../../assets/img/defaultAvatar.jpg');
        for (let player of this.state.playersFromApi) {
            playerList.push(
                <div className="team-page-grid-players-item" key={player.strPlayer}>
                <div className="team-page-grid-players-item-title">{player.strPlayer}</div>
                <div className="team-page-grid-players-item-img"><img src={player.strThumb == null ? player.strThumb : logoUrl} width="140px" /></div>
                <div className="team-page-grid-players-item-info">
                    <div>Born: {player.dateBorn}</div>
                    <div>Height: {player.strHeight}</div>
                </div>
            </div>
            );
        }

        return playerList;
    }


    componentWillUnmount() {
        this.props.ViewStore.changePreviousPage('Team');
    }

    render() {

        return (
            <div className="team-page">
                {!this.state.loading ?
                    <div className="team-page-grid">
                        <div className="team-page-grid-info">
                            <div className="team-page-grid-info-logo"><img src={this.state.currentTeam.logoUrl} width="100px" /></div>
                            <div className="team-page-grid-info-title">{this.state.currentTeam.name}</div>
                            <div className="team-page-grid-info-follow-btn"><FollowTeamBtn teamId={this.state.currentTeam._id} /></div>
                            <div className="team-page-grid-info-general-wrap">
                                <div className="team-page-grid-info-general">Sport: {this.state.teamFromApi.strSport}</div>
                                <div className="team-page-grid-info-general">League: {this.state.teamFromApi.strLeague}</div>
                                <div className="team-page-grid-info-general">Country: {this.state.teamFromApi.strCountry}</div>
                                <div className="team-page-grid-info-general">Founded: {this.state.teamFromApi.intFormedYear}</div>
                            </div>
                            <div className="team-page-grid-info-jersey">
                                <div className="team-page-grid-info-jersey-title">Jersey</div>
                                <div><img src={this.state.teamFromApi.strTeamJersey} width="140px" /></div>
                                <div className="team-page-grid-social-links">
                                    <div>Links</div>
                                    <div className="team-page-grid-social-links-icons">
                                    <a href={"http://" + this.state.teamFromApi.strWebsite} target="_blank"><FaExternalLinkAlt /></a> 
                                    <a href={"http://" + this.state.teamFromApi.strFacebook} target="_blank"><FaFacebook /></a> 
                                    <a href={"http://" + this.state.teamFromApi.strInstagram} target="_blank"><FaInstagram /></a> 
                                    <a href={"http://" + this.state.teamFromApi.strYoutube} target="_blank"><FaYoutubeSquare /></a> 
                                    <a href={"http://" + this.state.teamFromApi.strTwitter} target="_blank"><FaTwitterSquare /></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="team-page-grid-desc-players">
                            <div className="team-page-grid-desc-players-desc">{this.state.teamFromApi.strDescriptionEN}</div>
                            <div className="team-page-grid-players-title">Players<hr /></div>
                            <div className="team-page-grid-players">
                        {!this.state.loadingPlayers ? this.renderPlayers() : <Icon type="loading"/>}
                            </div>
                        </div>
                    </div>
                    : "Loading..."}
            </div>
        );
    }
}

export default inject('store')(observer(Team));


// WEBPACK FOOTER //
// ./src/components/appComponents/Team.js